import BaseReviewController from '../../components/base-review.controller';

class ReviewController  extends BaseReviewController{
    constructor(_, preFetchedData, componentRegistryService, componentDataService, disclosureService, loggerService, $state, constants, securityService, fileSaver, blobDownloadService) {
        super('reviewController',
            _,
            preFetchedData,
            componentRegistryService,
            componentDataService,
            disclosureService,
            loggerService,
            $state,
            constants,
            securityService,
            fileSaver,
            "/.coi.conflictofinterest",
            constants.DisclosureType.Conflict,
            blobDownloadService);
                  
        this.acknowledgements = constants.ConflictDetailsAcknowledgements;
        this.conflictCategories = preFetchedData.conflictCategories;
        this.lineManagers = preFetchedData.lineManager ? [preFetchedData.lineManager]:[];
        this.employmentOptions = preFetchedData.employmentOptions;
        this.hasAlternativeOfficer = preFetchedData.alternativeOfficer && !this._.isEmpty(preFetchedData.alternativeOfficer);
        this.reviewTitle = this.disclosureData.status === 'Draft' || this.disclosureData.status === 'Amending' || !this.disclosureData.displayId ? 'Disclosure of Relationships and Interests' : `COI ${this.disclosureData.displayId}`;
        this.canEdit = this.disclosureData.status === 'Submitted' || this.disclosureData.status === 'PendingAssessment';
        this.disclosureType = constants.DisclosureType.Conflict;
        this.strategyExists = this.disclosureData.managementStrategy !== null;
        this.managementStrategies = preFetchedData.managementStrategies;

        this.validateResponsibleOfficer = (curtinId) => {
            if (this.disclosureData.conflictRelationship && 
                this._.filter(this.disclosureData.conflictRelationship, (conflict) => conflict.curtinId.toUpperCase() === curtinId.toUpperCase()).length > 0) {
                return "The staff member listed in the conflict cannot be the assessor for this disclosure.";
            };
            return null;
        };        
    }

    
}

ReviewController.$inject = ['_', 'preFetchedData', 'componentRegistryService', 'componentDataService', 'disclosureService', 'loggerService', '$state', 'constants', 'securityService', 'FileSaver', 'blobDownloadService'];

export default ReviewController;



// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/review.controller.js